<template>
    <div class="layout-container">
        <div class="clearfix" style="margin: 20px 0;">
            <el-button-group class="floatL" >
                <el-button type="primary"   v-permission="'data.investments.config'"  @click="goAddPage()"  icon="el-icon-plus" >新增招商加盟400</el-button>
            </el-button-group>
        </div>
        <el-table
            :data="list"
            style="width: 100%"
            :highlight-current-row="true"
            stripe
            tooltip-effect="dark"
            ref="multipleTable"
            v-loading="isLoading"
            header-cell-class-name="table-back"
        >
            <el-table-column  label="推广渠道" prop="channel_name" ></el-table-column>
            <el-table-column  label="400号码" prop="hotline_number"></el-table-column>
            <el-table-column  label="400分机号" prop="telephone_number"></el-table-column>
            <el-table-column  label="号码类型" prop="type_name" ></el-table-column>
            <el-table-column  label="接听坐席"  min-width=200>
                <template slot-scope="scope">
                            <p v-html="scope.row.seat_str"></p>
                </template>
            </el-table-column>
            <el-table-column  label="绑定状态" prop="bind_status_name"></el-table-column>
            <el-table-column  label="更新时间" prop="updated_at" ></el-table-column>
            <el-table-column  label="操作" width=150  fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" v-if="scope.row.bind_status == 1"   v-permission="'data.investments.config'"  @click="$router.push({path: '/data/investment/tel/edit', query: {id:scope.row.id}})">编辑</el-button>
                    <el-button size="mini" type="danger"   v-permission="'data.investments.config'"  @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import { getInvesTelephone,getFormChannels ,deleInvesTelephone} from '@/service/investment'
    export default {
        name: "List",
       
        data () {
            return {
                site_id : 0,
                sites : [],
                list: [],
                isLoading: false,
                typeLength:0,
            }
        },
      
        mounted () {
            this.initData()
            this.initTypeList()
           
        },
        methods: {
             /** 初始化数据请求 */
            async initData () {
                this.list = []
                // 初始化之前设置当前页面的loading状态
                this.isLoading = true
                await getInvesTelephone().then((data) => {
                    for(let i in data){
                        let row = data[i]
                        row.seat_str='';
                        for(let a in row.seats){
                            row.seat_str += row.seats[a].staff_name +'('+row.seats[a].staff_phone+')<br />'
                        }
                    }
                    this.list=data
                })
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            },
            async initTypeList(){
                try {
                    const res = await getFormChannels()
                    let data =res.filter(function(v,i) {
                        return v.id!==1;
                    });
                    this.typeLength=data.length;
                } catch (error) {
                    const message = error.message
                    this.$message({
                        type: 'error',
                        message: message || '初始化推广列表失败'
                    })
                }
            },
            goAddPage(){
                this.$router.push({path: '/data/investment/tel/add'})
            },
            handleDelete(index,row){
                let params={
                    telephone_id:row.id
                }
                this.$confirm('是否确定删除【'+row.channel_name+'】渠道的通用400号码?', '提示').then(_ => {
                deleInvesTelephone(params).then((data) => {
                    this.$message({
                        message: '删除成功',
                        type: 'success',
                        duration: 3 * 1000
                    })
                    this.initData()
                }).catch(err => {
                    this.$message({
                        message: err.message || '删除失败',
                        type: 'error',
                        duration: 3 * 1000
                    })
                })
            }).catch(_ => {

            })
            },
        }
    }
</script>

<style scoped lang="less">
.layout-container{
    background-color: #fff;
    padding: 20px;
}
</style>
